export const getStatusStyles = (status) => {
    switch (status) {
      case 'Reverted':
        return {
          color: '#F00 !important',
          backgroundColor: 'rgba(255, 0, 0, 0.20)',
          svgColor: '#F00',
        };
      case 'Approved':
        return {
          color: '#058B2B !important',
          backgroundColor: 'rgba(5, 139, 43, 0.20)',
          svgColor: '#058B2B',
        };
      default:
        return {
          color: '#FF5C01 !important',
          backgroundColor: '#FFEFE6',
          svgColor: '#FF5C01',
        };
    }
  };